/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import { Box, Button, theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { ActiveFilters } from "~/components/Filters/ActiveFilters";
import { FiltersToggle } from "~/components/Filters/FiltersToggle";
import { DownloadReport } from "~/components/Report/DownloadReport";
import { FilteredSearch } from "~/components/Search/FilteredSearch";
import { ACTIONS, ROUTES, useAccess } from "~/routing";
import { isNotEmpty, useQueryState } from "~/tools";

export function CustomerNavbar() {
  const [state, , , removeFilter] = useQueryState();

  const { limit: ignoredLimit, page: ignoredPage, ...restFilters } = state;

  const activeFilters = Object.entries(restFilters);

  const showFilters = isNotEmpty(activeFilters);

  const { hasAccess: canBulkUpdate } = useAccess(ACTIONS.BULK_UPDATE);

  return (
    <Box boxStyle="lightGrey" spacing="spacing04">
      <FlexContainer justify="space-between" align="center">
        <FilteredSearch
          mode="customers"
          endpoint="customers"
          redirectLink={ROUTES.customers.index}
          options={{ keys: ["id", "name"] }}
        />
        <FiltersToggle />
        <DownloadReport />

        {canBulkUpdate && (
          <Link className="button-link" to={ROUTES.bulkUpdate}>
            <Button severity="low" icon="copy" css={{ marginLeft: "1rem" }}>
              Bulk update
            </Button>
          </Link>
        )}
      </FlexContainer>

      {showFilters && (
        <div css={{ marginTop: theme.spacing.spacing03 }}>
          {/* @ts-ignore */}
          <ActiveFilters filters={activeFilters} onRemoveKey={removeFilter} />
        </div>
      )}
    </Box>
  );
}
